module.exports = __webpack_public_path__ + "img/pt21_samurai02skin_shop.8b5ee884.png";